import script from "./ssh-disconnect-btn.vue?vue&type=script&setup=true&lang=ts"
export * from "./ssh-disconnect-btn.vue?vue&type=script&setup=true&lang=ts"

import "./ssh-disconnect-btn.vue?vue&type=style&index=0&id=203b9906&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-203b9906"]])

export default __exports__